import { useEffect } from 'react';
import { webmasterClient } from './webmasterClient';

/**
 * Automatically injects active webmaster verification meta tags into document.head
 */
export function useWebmasterVerification(): void {
  useEffect(() => {
    if (typeof document === 'undefined') return;

    webmasterClient.getVerifications().then((res) => {
      if (res.success && res.tokens) {
        for (const item of res.tokens) {
          if (!item.isActive || !item.token) continue;

          // Check if meta tag already exists
          let meta = document.querySelector(`meta[name="${item.metaName}"]`);
          if (!meta) {
            meta = document.createElement('meta');
            meta.setAttribute('name', item.metaName);
            document.head.appendChild(meta);
          }
          meta.setAttribute('content', item.token);
        }
      }
    });
  }, []);
}
